module.exports = __webpack_public_path__ + "static/media/insights.084953a1.png";